import React, { useState } from 'react';
import { doc, updateDoc, arrayUnion, Timestamp } from 'firebase/firestore';
import { db } from './firebase';
import './ScheduleDemo.css';

function ScheduleDemo({ school, onClose, onDemoScheduled }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    demoDate: '',
    demoTime: '',
    numberOfChildren: '',
    notes: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.demoDate || !formData.demoTime || !formData.numberOfChildren) {
      alert('Please fill in all required fields');
      return;
    }

    if (parseInt(formData.numberOfChildren) < 1) {
      alert('Number of children must be at least 1');
      return;
    }

    try {
      setLoading(true);

      // Create demo lesson object
      const demoLesson = {
        demoDate: formData.demoDate,
        demoTime: formData.demoTime,
        numberOfChildren: parseInt(formData.numberOfChildren),
        notes: formData.notes || '',
        scheduledAt: Timestamp.now(),
        status: 'scheduled' // Can be: scheduled, completed, cancelled
      };

      // Update school document with demo lesson
      const schoolRef = doc(db, 'schools', school.id);
      await updateDoc(schoolRef, {
        demoLessons: arrayUnion(demoLesson)
      });

      alert('Demo lesson scheduled successfully!');
      
      if (onDemoScheduled) {
        onDemoScheduled();
      }
      
      onClose();
    } catch (error) {
      console.error('Error scheduling demo:', error);
      alert('Error scheduling demo lesson. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content schedule-demo-modal">
        <div className="modal-header">
          <h2>📅 Schedule Demo Lesson</h2>
          <button onClick={onClose} className="close-btn">✕</button>
        </div>

        <div className="school-info-banner">
          <h3>{school.schoolName}</h3>
          <p>Code: {school.schoolCode}</p>
        </div>

        <form onSubmit={handleSubmit} className="demo-form">
          <div className="form-row">
            <div className="form-group">
              <label>Demo Date <span className="required">*</span></label>
              <input
                type="date"
                name="demoDate"
                value={formData.demoDate}
                onChange={handleChange}
                required
                min={new Date().toISOString().split('T')[0]}
              />
            </div>

            <div className="form-group">
              <label>Demo Time <span className="required">*</span></label>
              <input
                type="time"
                name="demoTime"
                value={formData.demoTime}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>Number of Children Expected <span className="required">*</span></label>
            <input
              type="number"
              name="numberOfChildren"
              value={formData.numberOfChildren}
              onChange={handleChange}
              min="1"
              max="100"
              required
              placeholder="e.g., 15"
            />
          </div>

          <div className="form-group">
            <label>Notes (Optional)</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              rows="3"
              placeholder="Any special notes or requirements for this demo..."
            />
          </div>

          <div className="form-actions">
            <button
              type="button"
              onClick={onClose}
              className="btn-cancel"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-submit"
              disabled={loading}
            >
              {loading ? 'Scheduling...' : 'Schedule Demo'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ScheduleDemo;